// extracted by mini-css-extract-plugin
export default {"partner-detail__buttons":"styles_partner-detail__buttons__EL9gX"};